import React from 'react';
import { Alert, Modal, Typography } from 'antd';

export type DisconnectCfTokenModalProps = {
  open: boolean;
  domain: string | null;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: string;
  onErrorDismissed?: () => void;
};

function DisconnectCfTokenModal({
  open,
  domain,
  onCancel,
  onConfirm,
  isLoading = false,
  error = '',
  onErrorDismissed = () => undefined,
}: DisconnectCfTokenModalProps) {
  return (
    <Modal
      closable={!isLoading}
      maskClosable={!isLoading}
      keyboard={!isLoading}
      title={`Disconnect the Cloudflare token for ${domain}?`}
      open={open}
      onCancel={onCancel}
      okText="Disconnect"
      okType="danger"
      onOk={onConfirm}
      okButtonProps={{ loading: isLoading, disabled: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Typography.Paragraph>Prerender deletes only its own copy of this token.</Typography.Paragraph>
      <Typography.Paragraph>The token stays active in Cloudflare until you revoke it.</Typography.Paragraph>
      <Typography.Paragraph>
        To revoke the token, go to Cloudflare. Go to My Profile. Then go to API Tokens.
      </Typography.Paragraph>

      {/* antd's Alert hides itself from state of its own, so the dismissal has to reach the
          error it was raised from or the same failure never shows again. */}
      {!!error && <Alert type="error" closable message={error} onClose={onErrorDismissed} />}
    </Modal>
  );
}

export default DisconnectCfTokenModal;
